export const translations = {
  he: {
    // Navbar
    nav: {
      home: 'בית',
      services: 'שירותים',
      whyUs: 'למה אנחנו',
      howItWorks: 'איך זה עובד',
      pricing: 'מחירים',
      contact: 'צור קשר',
      callNow: 'התקשרו עכשיו',
    },
    
    // Hero Section
    hero: {
      badge: 'פתח תקווה, השרון וראש העין',
      title: 'תיקון סלולרי',
      subtitle: 'עד הדלת שלך',
      description: 'לא צריך לנסוע למעבדה. המומחים שלנו מגיעים אליך — הביתה, למשרד, לכל מקום.',
      highlight: 'תיקון מהיר, מחיר הוגן,',
      warranty: 'ואחריות מלאה.',
      callButton: 'חייגו עכשיו',
      quoteButton: 'קבלו הצעת מחיר',
      badges: {
        warranty: 'אחריות מלאה',
        professional: 'שירות מקצועי',
        petahTikva: 'פתח תקווה והסביבה',
        sharon: 'השרון וראש העין',
      },
    },
    
    // Why Us Section
    whyUs: {
      title: 'למה לבחור בג\'יני מובייל?',
      subtitle: 'אנחנו לא עוד מעבדה. אנחנו שירות שמגיע אליך, עם מחיר שמכבד אותך ואחריות שמגנה עליך.',
      mainAdvantage: 'היתרון המרכזי',
      feature1: {
        title: 'באים עד הבית',
        description: 'אין צורך לנסוע, לחפש חניה או להמתין בתור. הטכנאי מגיע עד הבית או המשרד בזמן שמתאים לך. מותאם לסדר היום שלך.',
      },
      feature2: {
        title: 'שקיפות מחיר',
        description: 'שקיפות מלאה — מחיר ידוע מראש, ללא הפתעות. אתה יודע כמה זה עולה לפני שנתחיל.',
      },
      feature3: {
        title: 'אחריות ואמינות',
        description: '90% אחריות ושירות אמין. אם משהו קורה, אנחנו כאן בשבילך.',
      },
      feature4: {
        title: 'מהירות וזמינות',
        description: 'זמן תיקון מהיר — לרוב באותו יום. לא שבועות של המתנה. אנחנו יודעים שהזמן שלך יקר.',
      },
      feature5: {
        title: 'טכנאים מוסמכים',
        description: 'הטכנאים שלנו עברו הכשרה מקצועית, ויש להם ניסיון עשיר.',
      },
      feature6: {
        title: 'חווית שירות מעולה',
        description: 'הלקוח הוא במרכז. שירות אנושי, יחס אישי, ותמיד זמינים.',
      },
    },
    
    // Services Section
    services: {
      title: 'המחיר הכי משתלם בשוק — בהתחייבות!',
      subtitle: 'מחיר שקוף, ללא הפתעות, עם אחריות מלאה',
      types: [
        {
          title: 'תיקון מסך',
          description: 'מסך שבור? אנחנו מחליפים בחלקים מקוריים עם אחריות.',
          price: '₪299',
          features: ['החלפת זכוכית', 'תיקון LCD', 'אחריות מלאה'],
        },
        {
          title: 'בעיות סוללה',
          description: 'סוללה מתרוקנת מהר? אנחנו מחליפים בסוללה איכותית.',
          price: '₪199',
          features: ['סוללה איכותית', 'אחריות לשנה', 'שירות מהיר'],
        },
        {
          title: 'אבחון כללי',
          description: 'לא בטוח מה הבעיה? אבחון מקצועי ללא התחייבות.',
          price: '₪150',
          features: ['אבחון מקיף', 'ייעוץ מקצועי', 'ללא התחייבות'],
        },
      ],
      callButton: 'קבל הצעת מחיר',
      professionalService: 'שירות מקצועי,',
      priceRespect: 'מחיר שמכבד אותך',
      agreedPrice: 'כל מחיר מוסכם לפני התיקון — אחרי אבחון חינם ללא התחייבות.',
      alwaysIncluded: 'מה כלול תמיד',
      includedSubtitle: 'בכל תיקון, ללא תוספת תשלום',
      includedFeatures: [
        'אבחון מלא עולה 150 ש"ח',
        'הגעה עד הבית — ללא תוספת',
        'אחריות על 90 אחוז מהתיקונים',
        'חלקים איכותיים בלבד',
        'מחיר ידוע לפני התיקון',
        'טכנאי מוסמך ומנוסה',
      ],
      repairTypes: [
        { title: 'החלפת מסך', description: 'לכל הדגמים — iPhone, Samsung, Xiaomi ועוד' },
        { title: 'החלפת סוללה', description: 'סוללה מקורית ואיכותית — חיי סוללה כמו חדש' },
        { title: 'תיקון שקע טעינה', description: 'מחברים של תקינים — USB-C, Lightning' },
        { title: 'תיקון גב שבור', description: 'זכוכית אחורית לכל סדרות האייפון והסמסונג' },
        { title: 'תיקון רמקול ומיקרופון', description: 'קול חזק וברור כמו שצריך' },
        { title: 'תיקון מצלמה', description: 'החלפה ותיקון מצלמה קדמית ואחורית' },
      ],
    },
    
    // Tech Section
    tech: {
      title: 'התמחות בכל סוגי המכשירים',
      subtitle: 'מ-iPhone ועד Samsung — כל מותג, כל דגם, כל תקלה',
      brands: ['iPhone', 'Samsung', 'Xiaomi', 'Oppo', 'Huawei', 'Google Pixel'],
      labComesToYou: 'מעבדה שמגיעה אליך',
      labSubtitle: 'טכנאי מקצועי עם ציוד מלא שמגיע ישירות אליך ומתקן על המקום.',
      features: [
        {
          title: 'אבחון מדויק',
          description: 'משתמשים בציוד אבחון מקצועי לזיהוי מדויק של הבעיה — לא ניחושים, רק עובדות.',
        },
        {
          title: 'ציוד מקצועי',
          description: 'כלי עבודה מקצועיים ברמה גבוהה — אותם כלים שמשתמשים בהם מעבדות מורשות.',
        },
        {
          title: 'חלקים איכותיים',
          description: 'עובדים רק עם חלקי חילוף איכותיים שעוברים בדיקת איכות לפני התקנה.',
        },
        {
          title: 'ניסיון מעשי',
          description: 'שנים של ניסיון בתיקון כל סוגי הסמארטפון — כל תיקון מבוצע בקפידה ובמיומנות.',
        },
      ],
    },
    
    // How It Works Section
    howItWorks: {
      title: 'איך זה עובד?',
      subtitle: 'פשוט, מהיר, נוח',
      headerTitle: 'פשוט, מהיר, נוח לך',
      headerSubtitle: '4 צעדים פשוטים ואתה מחזיר לעצמך טלפון תקין — בלי לצאת מהבית.',
      steps: [
        {
          title: 'צור קשר',
          description: 'התקשר אלינו, שלח WhatsApp, או מלא את הטופס שקיים בתחתית האתר. נקשיב לבעיה ונספק הצעת מחיר מיידית.',
        },
        {
          title: 'קובעים מועד',
          description: 'קובעים זמן שנוח לך — אצלך בבית, בעבודה, או בכל מקום שתבחר. אנחנו מגיעים אליך.',
        },
        {
          title: 'תיקון מקצועי',
          description: 'הטכנאי מגיע עם כל הציוד הנדרש ומתקן את הטלפון שלך במקום, במהירות!',
        },
        {
          title: 'מחזירים לך שלם',
          description: 'הטלפון חוזר אליך תקין עם אחריות על התיקון. אתה ממשיך ביומך כאילו כלום לא קרה.',
        },
      ],
    },
    
    // Contact Section
    contact: {
      title: 'בואו נתחיל',
      subtitle: 'מלא את הטופס או התקשר ישירות',
      headerTitle: 'צור קשר',
      headerSubtitle: 'נשמח לעמוד לשירותכם. מלאו את הפרטים ונחזור אליכם בהקדם.',
      form: {
        name: 'שם מלא',
        phone: 'טלפון',
        phoneLabel: 'מספר טלפון *',
        phonePlaceholder: '050-000-0000',
        modelLabel: 'דגם הטלפון',
        modelPlaceholder: 'iPhone 14, Samsung S23...',
        issue: 'תאר את התקלה',
        issueLabel: 'תאר את הבעיה',
        issuePlaceholder: 'מה הבעיה בטלפון שלך?',
        submit: 'שלח',
        submitting: 'שולח...',
        successMessage: 'תודה! קיבלנו את הפנייה ונחזור אליך בהקדם',
      },
      info: {
        phone: 'טלפון',
        email: 'אימייל',
        hours: 'שעות פעילות',
        hoursValue: 'א׳-ו׳: 8:00-20:00',
        social: 'עקבו אחרינו',
      },
    },
    
    // Footer
    footer: {
      tagline: 'תיקון מכשירים ניידים עד הדלת',
      copyright: '© 2024 ג\'יני מובייל. כל הזכויות שמורות.',
      ownerInfo: 'עדיאל עמרם | פתח תקווה והסביבה',
      businessName: 'ג\'יני מובייל',
      ownerName: 'עדיאל עמרם',
      serviceArea: 'פתח תקווה והסביבה',
      builtWith: 'נבנה עם',
      forCustomers: 'עבור הלקוחות שלנו',
      social: {
        tiktok: 'TikTok',
        facebook: 'Facebook',
        instagram: 'Instagram',
      },
    },
    
    // Navbar
    nav: {
      home: 'בית',
      services: 'שירותים',
      whyUs: 'למה אנחנו',
      howItWorks: 'איך זה עובד',
      pricing: 'מחירים',
      contact: 'צור קשר',
      callNow: 'התקשרו עכשיו',
    },
  },
  
  en: {
    // Navbar
    nav: {
      services: 'Services',
      pricing: 'Pricing',
      whyUs: 'Why Us',
      contact: 'Contact',
      callNow: 'Call Now',
    },
    
    // Hero Section
    hero: {
      badge: 'Petah Tikva, Sharon & Rosh HaAyin',
      title: 'Mobile Repair',
      subtitle: 'At Your Doorstep',
      description: 'No need to visit a repair shop. Our experts come to you — at home, at the office, or anywhere.',
      highlight: 'Fast repairs, honest pricing,',
      warranty: 'and a warranty you can rely on.',
      callButton: 'Call Now',
      quoteButton: 'Get a Quote',
      badges: {
        warranty: 'Full Warranty',
        professional: 'Professional Service',
        petahTikva: 'Petah Tikva Area',
        sharon: 'Sharon & Rosh HaAyin',
      },
    },
    
    // Why Us Section
    whyUs: {
      title: 'Why Choose Genie Mobile?',
      subtitle: 'We\'re not just another repair center. We\'re a service that comes to you, with honest pricing and a warranty you can rely on.',
      mainAdvantage: 'Main Advantage',
      feature1: {
        title: 'We Come to You',
        description: 'No need to drive, find parking, or wait in line. Our technician comes to your home or office at a time that suits you. Scheduled at your convenience.',
      },
      feature2: {
        title: 'Price Transparency',
        description: 'Full transparency — pricing is known upfront, no surprises. You know how much it costs before we start.',
      },
      feature3: {
        title: 'Warranty & Reliability',
        description: 'Warranty on most repairs and reliable service. If something happens, we\'re here for you.',
      },
      feature4: {
        title: 'Speed & Availability',
        description: 'Fast repairs — usually same-day service. No weeks of waiting. We know your time is valuable.',
      },
      feature5: {
        title: 'Certified Technicians',
        description: 'Our technicians have undergone professional training and have extensive experience.',
      },
      feature6: {
        title: 'Excellent Service Experience',
        description: 'We put our customers first, with personal service, individual attention, and we\'re always here when you need us.',
      },
    },
    
    // Services Section
    services: {
      title: 'Best Market Price — Guaranteed!',
      subtitle: 'Transparent pricing, no surprises, with full warranty',
      types: [
        {
          title: 'Screen Repair',
          description: 'Broken screen? We replace it with original parts with warranty.',
          price: '₪299',
          features: ['Glass replacement', 'LCD repair', 'Full warranty'],
        },
        {
          title: 'Battery Issues',
          description: 'Battery draining fast? We replace it with a quality battery.',
          price: '₪199',
          features: ['Quality battery', 'One-year warranty', 'Fast service'],
        },
        {
          title: 'General Diagnosis',
          description: 'Not sure what\'s wrong? Professional diagnosis with no obligation.',
          price: '₪150',
          features: ['Comprehensive diagnosis', 'Professional advice', 'No obligation'],
        },
      ],
      callButton: 'Get a Quote',
      professionalService: 'Professional service,',
      priceRespect: 'honest pricing',
      agreedPrice: 'Every price is agreed before repair — after free diagnosis with no obligation.',
      alwaysIncluded: 'Always Included',
      includedSubtitle: 'In every repair, no additional charge',
      includedFeatures: [
        'Full diagnosis (₪150 value) — free',
        'Home visit — no extra charge',
        'Warranty included on most repairs',
        'Quality parts only',
        'Price confirmed before repair',
        'Certified and experienced technician',
      ],
      repairTypes: [
        { title: 'Screen Replacement', description: 'For all models — iPhone, Samsung, Xiaomi and more' },
        { title: 'Battery Replacement', description: 'High-quality battery — like-new performance' },
        { title: 'Charging Port Repair', description: 'USB-C and Lightning charging port repair' },
        { title: 'Back Glass Repair', description: 'Back glass replacement for all iPhone and Samsung models' },
        { title: 'Speaker & Microphone Repair', description: 'Clear, strong sound — just like it should be' },
        { title: 'Camera Repair', description: 'Front and rear camera replacement and repair' },
      ],
    },
    
    // Tech Section
    tech: {
      title: 'Expertise in All Device Types',
      subtitle: 'From iPhones to Samsung devices — all brands, all models, any issue',
      brands: ['iPhone', 'Samsung', 'Xiaomi', 'Oppo', 'Huawei', 'Google Pixel'],
      labComesToYou: 'A Repair Service That Comes to You',
      labSubtitle: 'A professional technician arrives fully equipped and repairs your device on-site.',
      features: [
        {
          title: 'Accurate Diagnosis',
          description: 'We use professional diagnostic equipment to identify the problem precisely — no guesswork, only facts.',
        },
        {
          title: 'Professional Equipment',
          description: 'Professional-grade tools — the same used by authorized repair centers.',
        },
        {
          title: 'Quality Parts',
          description: 'We use only high-quality parts that undergo quality testing before installation.',
        },
        {
          title: 'Practical Experience',
          description: 'Years of experience repairing all smartphone types — every repair is performed with precision and care.',
        },
      ],
    },
    
    // How It Works Section
    howItWorks: {
      title: 'How It Works?',
      subtitle: 'Simple, fast, convenient',
      headerTitle: 'Simple, fast, convenient for you',
      headerSubtitle: '4 simple steps to get your phone back up and running — without leaving home.',
      steps: [
        {
          title: 'Contact Us',
          description: 'Call us, send us a WhatsApp message, or fill out the form at the bottom of the site. We\'ll listen to the problem and give you an instant quote.',
        },
        {
          title: 'Schedule Appointment',
          description: 'Set a time that\'s convenient for you — at your home, office, or anywhere you choose. We come to you.',
        },
        {
          title: 'Professional Repair',
          description: 'The technician arrives with all necessary equipment and repairs your phone on-site, quickly!',
        },
        {
          title: 'Your Phone, Fixed',
          description: 'You get your phone back fully working with a warranty on the repair. You continue your day as if nothing happened.',
        },
      ],
    },
    
    // Contact Section
    contact: {
      title: 'Let\'s Get Started',
      subtitle: 'Fill out the form or call directly',
      headerTitle: 'Contact Us',
      headerSubtitle: 'We\'re happy to be at your service. Fill out the form and we\'ll get back to you soon.',
      form: {
        name: 'Full Name',
        phone: 'Phone',
        phoneLabel: 'Phone Number *',
        phonePlaceholder: '050-000-0000',
        modelLabel: 'Phone Model',
        modelPlaceholder: 'iPhone 14, Samsung S23...',
        issue: 'Describe the issue',
        issueLabel: 'Describe the problem',
        issuePlaceholder: 'What\'s wrong with your phone?',
        submit: 'Send',
        submitting: 'Sending...',
        successMessage: 'Thank you! We received your inquiry and will get back to you soon',
      },
      info: {
        phone: 'Phone',
        email: 'Email',
        hours: 'Business Hours',
        hoursValue: 'Sun–Fri: 8:00 AM – 8:00 PM',
        social: 'Follow Us',
      },
    },
    
    // Footer
    footer: {
      tagline: 'Mobile device repair at your doorstep',
      copyright: '© 2024 Genie Mobile. All rights reserved.',
      ownerInfo: 'Adiel Amram | Petah Tikva Area',
      businessName: 'Genie Mobile',
      ownerName: 'Adiel Amram',
      serviceArea: 'Petah Tikva, Sharon & Rosh HaAyin Area',
      builtWith: 'Built with',
      forCustomers: 'for our customers',
      social: {
        tiktok: 'TikTok',
        facebook: 'Facebook',
        instagram: 'Instagram',
      },
    },
    
    // Navbar
    nav: {
      home: 'Home',
      services: 'Services',
      whyUs: 'Why Us',
      howItWorks: 'How It Works',
      pricing: 'Pricing',
      contact: 'Contact',
      callNow: 'Call Now',
    },
  },
};
